module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Foreword"
    }
  }, [_vm._v("Foreword, by Joni Mayhan")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgments"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Timeline",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The History")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter01#h_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Battles of Lexington and Concord")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter01#h_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Concord’s Colonial Inn")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter01#h_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul Revere’s Ride")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Players")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter02#h_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ammi White")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter02#h_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dr. Timothy Minot")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter02#h_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry David Thoreau")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Hauntings")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter03#h_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ghostly Guests")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter03#h_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haunted Rooms")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter03#h_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TV Investigations")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Legends")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter04#h_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Louisa May Alcott")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter04#h_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nathaniel Hawthorne")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter04#h_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ralph Waldo Emerson")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Neighbors")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter05#h_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monument Square")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter05#h_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sleepy Hollow Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter05#h_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Old Manse")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Sources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b439491","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 63
// module chunks = 0